import FJTextToFullVideoStart from './FJTextToFullVideoStart';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';
import { TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE } from '../../../config/dataConfig/FJTextToVideoDataConfig.js';
const FJTextToFullVideoStartContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const freeNumCreationInfo = useSelector(state => state.textToVideo.freeNumCreationInfo);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const onGenerateScript = useCallback(() => {
        dispatch(FJActionTextToVideo.onTextToScriptAction());
    }, [dispatch]);
    const gotoPasteScript = useCallback(() => {
        dispatch(FJActionTextToVideo.gotoPasteScriptAction());
    }, [dispatch]);

    const defaultFreeNumCreation = useDefaultFreeLimit(TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT);

    return (
        <FJTextToFullVideoStart
            onGenerateScript={onGenerateScript}
            gotoPasteScript={gotoPasteScript}
            creditNumber={creditNumber}
            freeTimes={freeNumCreationInfo.textToScript}
            defaultFreeNumCreation={defaultFreeNumCreation}
        />
    );
};

export default FJTextToFullVideoStartContainer;
